<template>
  <div class="million-read-confirm">
    <ym-popup class="million-read-confirm-component-popup"
              v-model="visible"
              position="center"
              get-container="body"
    >
      <div class="million-read-confirm-container">
        <ym-img v-if="type === 'new-member'"
                class="million-read-confirm-new-member-deco"
                :src="require('@/assets/img/million_read/new_member_deco.png')"
        />
        <div v-if="title !== ''"
             class="million-read-confirm-header"
        >
          {{ title }}
        </div>
        <div class="million-read-confirm-content"
             :class="{ 'small': title !== '' }"
             v-html="content"
        ></div>
        <div class="million-read-confirm-action-bar">
          <div class="million-read-confirm-action-btn"
               @click="handleClose"
          >
            {{ cancelText }}
          </div>
          <div class="million-read-confirm-action-btn high-light"
               @click="handleConfirm"
          >
            {{ confirmText }}
          </div>
        </div>
        <div v-if="hint !== ''"
             class="million-read-confirm-hint"
             @click="handleClickHint"
        >
          {{ hint }}
        </div>
        <div v-else-if="!isLogin"
             class="million-read-confirm-hint"
             @click="handleClickLogin"
        >
          已加入？去登录>
        </div>
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';
  import { isAppWebView, locationHref, locationPath } from '@/utils';

  export default {
    name: 'MillionReadConfirm',
    components: {
      'ym-popup': Popup,
    },
    data() {
      return {
        visible: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        default: '',
      },
      content: {
        type: String,
        default: '',
      },
      hint: {
        type: String,
        default: '',
      },
      cancelText: {
        type: String,
        default: '取消',
      },
      confirmText: {
        type: String,
        default: '确定',
      },
      type: {
        type: String,
        default: '',
      },
      isLogin: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      redirectTo() {
        return this.$route.fullPath;
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      handleClose() {
        this.$emit('cancel');
        this.visible = false;
      },
      handleConfirm() {
        this.$emit('confirm');
        this.handleClose();
      },
      handleClickHint() {
        this.$emit('hint');
        this.handleClose();
      },
      handleClickLogin() {
        this.visible = false;
        const inAppWebView = isAppWebView();
        if (inAppWebView) {
          locationHref('youthmba://login/login');
          return;
        }
        locationPath(`/login?redirectTo=${this.redirectTo}`);
      },
    },
    created() {
      this.visible = this.show;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-confirm {
    &-component-popup {
      background: none;
    }
    &-container {
      box-sizing: border-box;
      position: relative;
      width: 630px;
      padding-bottom: 48px;
      background: @color-white;
      border-radius: 20px;
    }
    &-new-member-deco {
      position: absolute;
      top: -256px;
      left: 90px;
      width: 452px;
      height: 256px;
    }
    &-header {
      width: 100%;
      height: 112px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-text-base;
      font-size: @font-size-extra-large;
      font-weight: @font-weight-strong;
      line-height: 1;
      background: #fed100;
      border-radius: 20px 20px 0 0;
    }
    &-content {
      margin-bottom: 64px;
      padding-top: 90px;
      color: @color-text-base;
      font-size: @font-size-large;
      font-weight: @font-weight-strong;
      line-height: 1.5;
      text-align: center;
      &.small {
        padding-top: 64px;
        font-size: @font-size-medium;
      }
    }
    &-action-bar {
      box-sizing: border-box;
      padding: 0 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &-action-btn {
      width: 250px;
      height: 88px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-text-base;
      font-size: @font-size-medium;
      background: #f5f6fa;
      border-radius: 44px;

      &.high-light {
        background: #fed100;
      }
    }
    &-hint {
      margin-top: @size-base;
      color: @color-text-light;
      font-size: @font-size-base;
      font-weight: @font-weight-strong;
      line-height: 1;
      text-align: center;
    }
  }

</style>
